import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

interface SavebarProps {
  disableSave: boolean;
  onSave: () => void;
  onCancel: () => void;
}

function Savebar(props: SavebarProps) {
  const { disableSave, onSave, onCancel } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mt: 4,
      }}
    >
      <Button onClick={onCancel} color="inherit">
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={disableSave}
        onClick={onSave}
      >
        Save
      </Button>
    </Box>
  );
}

export default Savebar;
